const s = {
  name: "Biycle",
  dimensions: { width: 40, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 24" style="enable-background:new 0 0 40 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.3,2H15V0H8v2h3.1l6.2,15h5.3L27,6.5h0.3l1.4,3.5c-2.3,1.3-3.8,3.7-3.8,6.5c0,4.1,3.4,7.5,7.5,7.5
			s7.5-3.4,7.5-7.5S36.6,9,32.5,9c-0.6,0-1.3,0.1-1.9,0.2L28,2.8V2h4c0.8,0,1.5,0.7,1.5,1.5C33.5,4.3,32.8,5,32,5h-1v2h1
			c1.9,0,3.5-1.6,3.5-3.5C35.5,1.6,33.9,0,32,0h-6v3.2l0.5,1.3H14.3L13.3,2z M29.5,11.9l2,5l1.9-0.8l-2-5c0.4-0.1,0.7-0.1,1.1-0.1
			c3,0,5.5,2.5,5.5,5.5S35.5,22,32.5,22c-3,0-5.5-2.5-5.5-5.5C27,14.6,28,12.8,29.5,11.9z M18.7,15l-3.5-8.5h9.7L21.3,15H18.7z"/>
		<path class="st0" d="M0,16.5C0,12.4,3.4,9,7.5,9c4.1,0,7.5,3.4,7.5,7.5S11.6,24,7.5,24C3.4,24,0,20.6,0,16.5z M7.5,11
			c-3,0-5.5,2.5-5.5,5.5S4.5,22,7.5,22c3,0,5.5-2.5,5.5-5.5S10.5,11,7.5,11z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Biycle
};
